import { arrayUnion, doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import getFormSession from "../../../Components/CluppForms/getFormSession";
import saveFormRecord from "../../../Components/CluppForms/saveFormRecord";
import RatingReferal from "./RatingReferal";

const landingId = "CF_RATING_REFERAL";

const onLoad = async ({
  session,
  landedAt,
  uid,
  fieldsStructure,
  navigate,
}) => {
  const prevAnswers = {};
  let lastRanking = 0;
  const prevForm = await getFormSession("cancelation-form", session.sessionID);
  const landings = prevForm.items;

  landings.forEach((item) => {
    if (item.answers.length > 0) {
      const lastField = item?.answers[0];
      const fieldID = lastField.field.id;
      const lastFieldType = lastField.type;
      const lastFieldAnswers = lastField[lastFieldType]?.value;
      prevAnswers[fieldID] = lastFieldAnswers;
    }
  });
  const itemsFromThisLanding = prevForm.items.find(
    (items) => items.landingId === landingId
  );
  if (itemsFromThisLanding) {
    const thisField = itemsFromThisLanding?.answers[0];
    const thisFieldType = thisField.type; // choice
    lastRanking = thisField[thisFieldType].value;
  }
  if (!lastRanking) {
    const thisField = fieldsStructure[0];
    const thisFieldType = thisField.type;
    lastRanking = thisField[thisFieldType].value;
  }

  return {
    userId: uid,
    ...prevAnswers,
    [fieldsStructure[0].field.id]: lastRanking,
    landedAt,
    prevForm,
    currentLanding: landingId,
  };
};

const onSubmit = async ({
  state,
  session,
  fieldsStructure,
  nextPage,
  navigate,
}) => {
  if (session?.sessionID) {
    try {
      const path = `IT/forms/cancelation-form/${session.sessionID}`;
      const docRef = doc(db, path);
      const prevForm = state.prevForm;

      const newLanding = {
        landingId,
        landedAt: state.landedAt,
        submittedAt: Date.now(),
      };

      const answerStructure = fieldsStructure[0];
      const fieldType = answerStructure.type;
      const filedName = answerStructure.field.id;
      answerStructure[fieldType].value = state[filedName];

      newLanding.answers = [answerStructure];

      const thisItemExists = prevForm.items.find(
        (item) => item.landingId === landingId
      );

      const updateData = thisItemExists
        ? [
            ...prevForm.items.filter((item) => item.landingId !== landingId),
            newLanding,
          ]
        : arrayUnion(newLanding);

      await saveFormRecord(session.sessionID, {
        ...prevForm,
        items: updateData,
      });
      await updateDoc(docRef, {
        items: updateData,
        processed: false
      });

      console.log("State successfully written to Firestore!");
      if (nextPage) navigate(nextPage(state));
    } catch (err) {
      console.error("Error writing document to Firestore: ", err);
    }
  }
};

const content = ({ state, setState }) => (
  <RatingReferal
    state={state}
    setState={setState}
    field={"CF_raiting_referal_s23sg"}
  /> // Field ID
);

const nextPage = (props) => {
  const value = props["CF_raiting_referal_s23sg"];
  if (value > 7) {
    return `/formulario/cancelacion/reseña?uid=${props.uid}`;
  }
  return `/formulario/cancelacion/mejoras?uid=${props.uid}`;
};
const prevPage = (props) => `/formulario/cancelacion/servicio?uid=${props.uid}`;

const fieldsStructure = [
  {
    field: {
      id: "CF_raiting_referal_s23sg",
      type: "range_numbers",
      ref: "CF_raiting_referal",
    },
    metadata: {},
    type: "range_numbers",
    range_numbers: {
      value: 10,
    },
  },
];

const ratingReferalProps = {
  landingId,
  onLoad,
  onSubmit,
  content,
  nextPage,
  prevPage,
  fieldsStructure,
};

export default ratingReferalProps;
